import { useMemo } from "react";
import { useFeature } from "@radarly/core/features/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { WizardTemplate } from "@radarly/models/insight-pages/wizard/model";

const SECTION_TO_FILTER = ["query", "queries", "personIdentifications"];

export function useWizardSidebar(template: WizardTemplate) {
  const locale = useCurrentUserLocale();
  const isAIWizardEnabled = useFeature("ai_wizard");
  const editionSections = useMemo(() => {
    const sections = template.sections.reduce(
      (acc, section) => {
        if (section.type === "cards") {
          return [...acc, ...section.clause];
        }
        return acc;
      },
      isAIWizardEnabled ? ["properties", "aiContext"] : ["properties"]
    );
    return [...new Set(sections)].filter(
      (section) => !SECTION_TO_FILTER.includes(section)
    );
  }, [isAIWizardEnabled, template.sections]);

  const sections = useMemo(
    () =>
      editionSections.map((section) => ({
        type: section,
        label: tr(
          locale,
          `INSIGHT_PAGE_WIZARD::CONFIGURATION_SECTION_${section}`
        ),
      })),
    [locale, editionSections]
  );

  return {
    sections,
  };
}
